<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<form [formGroup]="form" *ngIf="form">
  <div [dir]="data.dir" class="row">
    <div class="col-sm-6 mb-2">
      <mat-label class="font-weight-bold field-required">{{ "forms.common.Criteria.responseDecision" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="responseDecision">
          <mat-option *ngFor="let option of responses" [value]="option">
            {{ "forms.common.Criteria." + option | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mb-2" *ngIf="responseDecisionValue && responseDecisionValue != 'accept'">
      <mat-label class="font-weight-bold field-required">{{ "forms.common.Criteria.reasons" | translate }} </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="reasons"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mb-2" *ngIf="form.controls.responseDecision.value == 'accept_update'">
      <div class="d-flex justify-content-between align-items-baseline">
        <mat-label class="font-weight-bold field-required">{{ "forms.common.Criteria.updates" | translate }}
        </mat-label>
        <button mat-icon-button matTooltip="{{ 'forms.common.Add' | translate }}" (click)="addUpdate()"
          *ngIf="!data.viewOnly">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <ng-container formArrayName="updates">
        <div class="d-flex" *ngFor="let control of updatesControls; let index = index">
          <mat-form-field appearance="outline">
            <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [formControl]="control"></textarea>
          </mat-form-field>
          <button mat-icon-button (click)="removeUpdate(index)" *ngIf="!data.viewOnly">
            <mat-icon color="warn">delete_forever</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>

    <div class="col-sm-12 mt-2 d-flex justify-content-end">
      <button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
        {{ "forms.common.cancel" | translate }}
      </button>
      <button *ngIf="!data.viewOnly" mat-flat-button (click)="save()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </div>
</form>